import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

interface Props {
  background: string
}
export const TagStyled = styled.span<Props>`
  color: white;
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.md};
  display: inline-flex;
  place-content: center;
  align-items: center;
  padding: ${theme.spacing.xs};
  min-width: 45px;
  width: fit-content;
  height: ${theme.spacing.xm};
  background: ${({ background }) => background};
  border-radius: 2px;
`
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.xs};
`
